import { render, staticRenderFns } from "./BaseIconButtonSkeleton.vue?vue&type=template&id=5688d9ba&scoped=true"
import script from "./BaseIconButtonSkeleton.vue?vue&type=script&lang=js"
export * from "./BaseIconButtonSkeleton.vue?vue&type=script&lang=js"
import style0 from "./BaseIconButtonSkeleton.vue?vue&type=style&index=0&id=5688d9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5688d9ba",
  null
  
)

export default component.exports